<template>
  <VSelect v-model="model" clearable :disabled filterable :label="placeholder ? undefined : $t('modules')" multiple :placeholder :size>
    <VOption v-for="role in visibleRoles" :key="role.id" :label="$tk(role.name)" :value="role.name" />
  </VSelect>
</template>

<script setup lang="ts">
import type { VInputSize } from '@vartion/ui'

import { APP_MODULE_ROLES, useRoles } from '~/stores/roles.ts'

interface Props {
  disabled?: boolean
  size?: VInputSize
  placeholder?: string
}

const { disabled = undefined, size = undefined, placeholder = undefined } = defineProps<Props>()

const model = defineModel<string[]>({ required: true })

const store = useRoles()

const visibleRoles = computed(() => Object.values(store.appRoles).filter((role) => APP_MODULE_ROLES.has(role.name)))
</script>
